import { render, staticRenderFns } from "./reset-success.vue?vue&type=template&id=74f3fc81&scoped=true&"
import script from "./reset-success.vue?vue&type=script&lang=js&"
export * from "./reset-success.vue?vue&type=script&lang=js&"
import style0 from "./reset-success.vue?vue&type=style&index=0&id=74f3fc81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f3fc81",
  null
  
)

export default component.exports